// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__vY8Fx","active":"styles_active__AFYiM","icon":"styles_icon__xThrA","arrow":"styles_arrow__w_JyF","open":"styles_open__Wnhs4"};